<template>
  <v-dialog
    :value="showModal"
    @input="$store.commit('devs/toggleModal', $event)"
    fullscreen
    transition="fade-transition"
    light
  >
    <v-card class="d-flex flex-column">
      <v-card flat dark color="primary" class="d-flex align-center pa-3">
        <div class="text-h5 font-weight-bold">
          {{ mode === 'create' ? 'Create' : 'Update' }} dev
        </div>
        <v-chip small class="ml-5 black--text" color="accent">
          ID: <b class="ml-1">{{ selected.pub_id }}</b>
        </v-chip>
        <v-spacer></v-spacer>
        <v-btn
          class="mr-4"
          @click="transformToUser"
          :loading="loading"
          :disabled="selected.user"
        >
          Set as user
        </v-btn>
        <v-btn
          class="mr-4"
          @click="sendPass"
          :loading="loading"
        >
          Send Pasword
        </v-btn>
        <v-btn
          class="mr-4"
          :href="selected.cv_url"
          :disabled="!selected.cv_url"
          target="_blank"
        >
          CV
          <v-icon right>mdi-download</v-icon>
        </v-btn>
        <v-btn
          @click="save"
          :loading="loading"
          class="mr-4"
        >
          Save
          <v-icon right>mdi-content-save</v-icon>
        </v-btn>
        <v-btn icon @click="$store.commit('devs/closeModal')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>

      <v-row class="px-10">
        <v-col md="3" cols="12" class="d-flex flex-column">
          <ImageInput 
            @file-upload="onFileUpload" 
            :image="selected.avatar_url"
            class="align-self-center mb-5"
          />
          <v-select
            class="mt-3"
            hide-details
            :items="[
              'default',
              'gamer',
              'girl-cheers',
              'girl-leader',
              'analitic',
              'guy-beard',
              'indian',
            ]"
            v-model="selected.placeholder_image"
          ></v-select>
        </v-col>
        <v-col md="3" cols="12" class="d-flex flex-column">
          <MainInfo/>
        </v-col>
        <v-col md="3" cols="12" class="d-flex flex-column">
          <ContactInfo/>
        </v-col>
        <v-col md="3" cols="12" class="d-flex flex-column">
          <v-responsive :aspect-ratio="1" width="100%">
            <pre class="grey lighten-3 rounded pa-3" style="position: absolute; height: 100%; width: 100%; overflow: auto;">{{ selected.form }}</pre>
          </v-responsive>
        </v-col>
      </v-row>

      <div class="d-flex flex-column flex-grow-1">
        <v-tabs dark v-model="tab" center-active background-color="primary">
          <v-tab key="edu">
            Education
          </v-tab>
          <v-tab key="tech">
            Technologies
          </v-tab>
          <v-tab key="lang">
            Languages
          </v-tab>
          <v-tab key="port">
            Portfolio
          </v-tab>
          <v-tab key="exp">
            Experience
          </v-tab>
          <v-tab key="comments">
            Comments
          </v-tab>
        </v-tabs>

        <v-tabs-items @change="onChange" class="py-10" light v-model="tab">
          <v-tab-item transition="fade-transition" class="px-10" key="edu">
            <EducationSection/>
          </v-tab-item>
          <v-tab-item transition="fade-transition" class="px-10" key="tech">
            <TechnologiesSection/>
          </v-tab-item>
          <v-tab-item transition="fade-transition" class="px-10" key="lang">
            <LangSection/>
          </v-tab-item>
          <v-tab-item transition="fade-transition" class="px-10" key="port">
            <PortfolioSection/>
          </v-tab-item>
          <v-tab-item transition="fade-transition" class="px-10" key="exp">
            <ExpSection/>
          </v-tab-item>
          <v-tab-item transition="fade-transition" class="px-10" key="comments">
            <DevComments ref="comment-section"/>
          </v-tab-item>
        </v-tabs-items>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import ImageInput from '@/components/ImageInput';
import EducationSection from './EducationSection';
import ContactInfo from './ContactInfo';
import MainInfo from './MainInfo';
import PortfolioSection from './PortfolioSection';
import LangSection from './LangSection';
import TechnologiesSection from './TechnologiesSection';
import ExpSection from './ExpSection';
import DevComments from './DevComments';
import { DevsAPI } from '@/api';

export default {
  data() {
    return {
      loading: false,
      techs: require('@/assets/techs').default,
      timezones: require('@/assets/timezones').default,
      tab: 'exp',
    }
  },
  methods: {
    onFileUpload(file_id) {
      this.selected.avatar = file_id;
    },
    save() {
      this.loading = true;
      this.$store.dispatch('devs/save').finally(() => {
        this.loading = false;
      })
    },
    onChange() {
      this.$refs['comment-section'].sync()
    },

    transformToUser() {
      this.loading = true;
      DevsAPI.transformToUser(this.selected._id)
        .then(async () => {
          await this.$store.dispatch('devs/updateData');
          this.$store.commit('devs/closeModal');
        })
        .finally(() => {
          this.loading = false;
        })
    },

    sendPass() {
      this.loading = true;
      DevsAPI.sendPass(this.selected._id).finally(() => {
        this.loading = false;
      })
    },
  },
  components: {
    ImageInput,
    EducationSection,
    ContactInfo,
    MainInfo,
    PortfolioSection,
    LangSection,
    TechnologiesSection,
    ExpSection,
    DevComments,
  },
  computed: {
    ...mapGetters({
      selected: 'devs/selected',
      mode: 'devs/mode',
      showModal: 'devs/showModal',
    }),
  },
}
</script>

<style lang="scss" scoped>



</style>